export const CELL_TYPES = {
  DESERT:  'desert',
  SHEEP:   'sheep',
  CLAY:    'clay',
  WHEAT:   'wheat',
  MOUNTAIN:'mountain',
  FOREST:  'forest',
}

export function renderCell(cx, cy) {
  return [renderDesert(cx, cy),
        renderSheep(cx, cy),
         renderClay(cx, cy),
        renderWheat(cx, cy),
     renderMountain(cx, cy),
       renderForest(cx, cy),
  ]
}

// ─── ВІВЦЯ ────────────────────────────────────────────────────────────
function renderSheep(cx, cy) { return { bg: '#4caf50', elements: [
  { tag: 'ellipse', cx: cx,    cy: cy+5,  rx: 32, ry: 28, fill: '#00000018' },
  { tag: 'ellipse', cx: cx-23, cy: cy-20, rx: 5, ry: 8,  fill: '#c8c4be', transform: `rotate(-30,${cx-23},${cy-20})` },
  { tag: 'ellipse', cx: cx-23, cy: cy-24, rx: 4, ry: 3,  fill: '#5d4037' },
  { tag: 'ellipse', cx: cx+23, cy: cy-20, rx: 5, ry: 8,  fill: '#c8c4be', transform: `rotate(30,${cx+23},${cy-20})` },
  { tag: 'ellipse', cx: cx+23, cy: cy-24, rx: 4, ry: 3,  fill: '#5d4037' },
  { tag: 'ellipse', cx: cx-23, cy: cy+22, rx: 5, ry: 8,  fill: '#c8c4be', transform: `rotate(30,${cx-23},${cy+22})` },
  { tag: 'ellipse', cx: cx-23, cy: cy+26, rx: 4, ry: 3,  fill: '#5d4037' },
  { tag: 'ellipse', cx: cx+23, cy: cy+22, rx: 5, ry: 8,  fill: '#c8c4be', transform: `rotate(-30,${cx+23},${cy+22})` },
  { tag: 'ellipse', cx: cx+23, cy: cy+26, rx: 4, ry: 3,  fill: '#5d4037' },
  { tag: 'circle',  cx: cx,    cy: cy,    r: 24,  fill: '#f0ede8' },
  { tag: 'circle',  cx: cx-14, cy: cy-10, r: 12,  fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx,    cy: cy-15, r: 13,  fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx+14, cy: cy-10, r: 12,  fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx+18, cy: cy+2,  r: 11,  fill: '#f0ede8' },
  { tag: 'circle',  cx: cx+14, cy: cy+13, r: 12,  fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx,    cy: cy+16, r: 12,  fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx-14, cy: cy+13, r: 11,  fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx-18, cy: cy+2,  r: 11,  fill: '#f0ede8' },
  { tag: 'ellipse', cx: cx,    cy: cy+1,  rx: 16, ry: 15, fill: '#ece9e3' },
  { tag: 'ellipse', cx: cx,    cy: cy-20, rx: 10, ry: 9,  fill: '#e8e4de' },
  { tag: 'ellipse', cx: cx-11, cy: cy-20, rx: 5,  ry: 3,  fill: '#d4b8a0', transform: `rotate(-15,${cx-11},${cy-20})` },
  { tag: 'ellipse', cx: cx+11, cy: cy-20, rx: 5,  ry: 3,  fill: '#d4b8a0', transform: `rotate(15,${cx+11},${cy-20})` },
  { tag: 'ellipse', cx: cx,    cy: cy-20, rx: 13, ry: 12, fill: '#bbdefb', opacity: 0.3, stroke: '#90caf9', strokeWidth: 1.5 },
  { tag: 'ellipse', cx: cx-4,  cy: cy-25, rx: 4,  ry: 3,  fill: 'white',   opacity: 0.4 },
  { tag: 'circle',  cx: cx-4,  cy: cy-20, r: 2,   fill: '#333' },
  { tag: 'circle',  cx: cx+4,  cy: cy-20, r: 2,   fill: '#333' },
  { tag: 'circle',  cx: cx-3,  cy: cy-21, r: 0.8, fill: 'white' },
  { tag: 'circle',  cx: cx+5,  cy: cy-21, r: 0.8, fill: 'white' },
  { tag: 'circle',  cx: cx,    cy: cy+26, r: 5,   fill: '#f5f3ef' },
  { tag: 'circle',  cx: cx,    cy: cy+26, r: 3,   fill: '#e8e4de' },
]}}

// ─── ГЛИНА ────────────────────────────────────────────────────────────
function renderClay(cx, cy) { return { bg: '#bf8a60', elements: [
  { tag: 'ellipse', cx: cx-15, cy: cy-10, rx: 18, ry: 12, fill: '#a0522d', opacity: 0.5 },
  { tag: 'ellipse', cx: cx+10, cy: cy+8,  rx: 14, ry: 9,  fill: '#8b4513', opacity: 0.4 },
  { tag: 'ellipse', cx: cx,    cy: cy-5,  rx: 22, ry: 14, fill: '#cd853f', opacity: 0.6 },
  { tag: 'ellipse', cx: cx-20, cy: cy+15, rx: 10, ry: 7,  fill: '#a0522d', opacity: 0.5 },
  { tag: 'ellipse', cx: cx+18, cy: cy-18, rx: 8,  ry: 6,  fill: '#8b4513', opacity: 0.4 },
  { tag: 'ellipse', cx: cx+5,  cy: cy+18, rx: 16, ry: 8,  fill: '#cd853f', opacity: 0.5 },
  { tag: 'circle',  cx: cx-10, cy: cy+5,  r: 6,   fill: '#b8732a' },
  { tag: 'circle',  cx: cx+12, cy: cy-8,  r: 5,   fill: '#c4813a' },
  { tag: 'circle',  cx: cx-5,  cy: cy+20, r: 4,   fill: '#b8732a' },
  { tag: 'circle',  cx: cx+20, cy: cy+10, r: 4,   fill: '#c4813a' },
  { tag: 'circle',  cx: cx-22, cy: cy-5,  r: 5,   fill: '#b8732a' },
]}}

// ─── ГОРИ З КАМІННЯМ ──────────────────────────────────────────────────
function renderMountain(cx, cy) { return { bg: '#78909c', elements: [
  { tag: 'polygon', points: `${cx-30},${cy+20} ${cx-5},${cy-25} ${cx+20},${cy+20}`, fill: '#546e7a' },
  { tag: 'polygon', points: `${cx-5},${cy+20} ${cx+22},${cy-20} ${cx+45},${cy+20}`, fill: '#607d8b' },
  { tag: 'polygon', points: `${cx-20},${cy+20} ${cx+5},${cy-30} ${cx+30},${cy+20}`, fill: '#78909c' },
  { tag: 'polygon', points: `${cx+5},${cy-30} ${cx-2},${cy-22} ${cx+12},${cy-22}`, fill: 'white', opacity: 0.7 },
  { tag: 'polygon', points: `${cx-5},${cy-25} ${cx-11},${cy-18} ${cx+1},${cy-18}`,  fill: 'white', opacity: 0.5 },
  { tag: 'ellipse', cx: cx-25, cy: cy+22, rx: 7,  ry: 4,  fill: '#455a64', transform: `rotate(10,${cx-25},${cy+22})` },
  { tag: 'ellipse', cx: cx-18, cy: cy+26, rx: 5,  ry: 3,  fill: '#546e7a', transform: `rotate(-5,${cx-18},${cy+26})` },
  { tag: 'ellipse', cx: cx+30, cy: cy+24, rx: 6,  ry: 3.5,fill: '#455a64', transform: `rotate(15,${cx+30},${cy+24})` },
  { tag: 'ellipse', cx: cx+10, cy: cy+26, rx: 8,  ry: 4,  fill: '#546e7a', transform: `rotate(-8,${cx+10},${cy+26})` },
]}}

// ─── ПУСТЕЛЯ ──────────────────────────────────────────────────────────
function renderDesert(cx, cy) { return { bg: '#e6c97a', elements: [
  { tag: 'ellipse', cx: cx-20, cy: cy+10, rx: 25, ry: 8,  fill: '#d4a843', opacity: 0.5 },
  { tag: 'ellipse', cx: cx+15, cy: cy-15, rx: 20, ry: 7,  fill: '#c9973a', opacity: 0.4 },
  { tag: 'ellipse', cx: cx,    cy: cy+20, rx: 30, ry: 9,  fill: '#d4a843', opacity: 0.4 },
  { tag: 'ellipse', cx: cx-10, cy: cy-5,  rx: 22, ry: 6,  fill: '#c9973a', opacity: 0.3 },
  { tag: 'ellipse', cx: cx-25, cy: cy-8,  rx: 6,  ry: 4,  fill: '#90a4ae', transform: `rotate(10,${cx-25},${cy-8})` },
  { tag: 'ellipse', cx: cx-20, cy: cy-4,  rx: 4,  ry: 2.5,fill: '#b0bec5', transform: `rotate(-5,${cx-20},${cy-4})` },
  { tag: 'ellipse', cx: cx+28, cy: cy+5,  rx: 5,  ry: 3,  fill: '#90a4ae', transform: `rotate(-10,${cx+28},${cy+5})` },
  { tag: 'polygon', points: `${cx+5},${cy-20} ${cx+8},${cy-5} ${cx+2},${cy-5}`, fill: '#8d6e63' },
  { tag: 'ellipse', cx: cx+5,  cy: cy-22, rx: 8,  ry: 5,  fill: '#558b2f' },
  { tag: 'ellipse', cx: cx+2,  cy: cy-20, rx: 6,  ry: 4,  fill: '#689f38' },
  { tag: 'polygon', points: `${cx-18},${cy+5} ${cx-15},${cy+18} ${cx-21},${cy+18}`, fill: '#8d6e63' },
  { tag: 'ellipse', cx: cx-18, cy: cy+3,  rx: 7,  ry: 4,  fill: '#558b2f' },
  { tag: 'circle',  cx: cx+20, cy: cy+15, r: 3,   fill: '#d4a843', opacity: 0.8 },
  { tag: 'circle',  cx: cx-5,  cy: cy+5,  r: 2,   fill: '#c9973a', opacity: 0.7 },
  { tag: 'circle',  cx: cx+10, cy: cy-10, r: 2.5, fill: '#d4a843', opacity: 0.6 },
]}}

// ─── ПШЕНИЧНЕ ПОЛЕ ────────────────────────────────────────────────────
function renderWheat(cx, cy) { return { bg: '#f9a825', elements: [
  ...[
    [cx-30,cy+15],[cx-20,cy+15],[cx-10,cy+15],[cx,cy+15],[cx+10,cy+15],[cx+20,cy+15],[cx+30,cy+15],
    [cx-25,cy],   [cx-15,cy],   [cx-5,cy],    [cx+5,cy], [cx+15,cy],   [cx+25,cy],
    [cx-20,cy-15],[cx-10,cy-15],[cx,cy-15],   [cx+10,cy-15],[cx+20,cy-15],
    [cx-10,cy-28],[cx,cy-28],   [cx+10,cy-28],
  ].flatMap(([x, y]) => [
    { tag: 'line', x1: x, y1: y, x2: x-3, y2: y-20, stroke: '#e65100', strokeWidth: 1.5, strokeLinecap: 'round' },
    { tag: 'line', x1: x, y1: y, x2: x+3, y2: y-20, stroke: '#e65100', strokeWidth: 1.5, strokeLinecap: 'round' },
    { tag: 'line', x1: x, y1: y, x2: x,   y2: y-22, stroke: '#f57f17', strokeWidth: 1.5, strokeLinecap: 'round' },
    { tag: 'ellipse', cx: x-3, cy: y-23, rx: 3, ry: 6, fill: '#fbc02d', transform: `rotate(-10,${x-3},${y-23})` },
    { tag: 'ellipse', cx: x+3, cy: y-23, rx: 3, ry: 6, fill: '#f9a825', transform: `rotate(10,${x+3},${y-23})` },
    { tag: 'ellipse', cx: x,   cy: y-25, rx: 2.5, ry: 5, fill: '#fdd835' },
  ]),
]}}

// ─── ЛІС ──────────────────────────────────────────────────────────────
function renderForest(cx, cy) { return { bg: '#2e7d32', elements: [
  ...[
    [cx,    cy-10, 18, '#1b5e20'],
    [cx-22, cy,    15, '#2e7d32'],
    [cx+22, cy,    15, '#1b5e20'],
    [cx-12, cy+18, 14, '#2e7d32'],
    [cx+12, cy+18, 14, '#388e3c'],
    [cx,    cy+28, 13, '#1b5e20'],
    [cx-28, cy-5,  12, '#388e3c'],
    [cx+28, cy-5,  12, '#2e7d32'],
  ].flatMap(([x, y, r, fill]) => [
    { tag: 'circle', cx: x, cy: y+r*0.3, r: r*0.35, fill: '#4e342e' },
    { tag: 'circle', cx: x, cy: y,       r: r,       fill },
    { tag: 'ellipse',cx: x-r*0.3, cy: y-r*0.3, rx: r*0.3, ry: r*0.25, fill: 'white', opacity: 0.12 },
  ]),
  { tag: 'circle', cx: cx-5,  cy: cy+5,  r: 3, fill: '#795548', opacity: 0.6 },
  { tag: 'circle', cx: cx+18, cy: cy+22, r: 2, fill: '#795548', opacity: 0.5 },
]}}